import { Injectable, Inject} from '@angular/core';
import {BaseDO} from './base.model';


 export abstract class BasePolicyPremiumBreakupDO extends BaseDO {


    public discountPrct:number;
    public discount:number;
    public commissionPrct:number;
    public commission:number;
    public adminCharges:number;
    public stampDuty:number;
    public totalBasePremium:number;
    public totalExtraPremium:number;
    public totalUWExtraPremium:number;
    public totalPremium:number;
    public promotionalDiscount:number;

 }